var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap--sub"
  }, [_c('sub-visual', {
    attrs: {
      "visual": _vm.$t('common.자주 묻는 질문')
    }
  }), _c('div', {
    staticClass: "contents"
  }, [_c('div', {
    staticClass: "ct"
  }, [_c('faq-list')], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }